// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"qW2Lk","goBack":"_1p8eD","block":"_1E_nG","return":"_3cCbm","headerBlock":"_33-Y7","dropdown":"_1meAP","button":"DsKAj","description":"_54ywV","footerBox":"_2Ux2g"};